"use client";

import { Facebook, Instagram, Leaf, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const services = [{
  label: "Fractional CTO Services"
}, {
  label: "Eir SaaS Platform"
}, {
  label: "Custom Software Development"
}, {
  label: "Precision Genetic Testing"
}, {
  label: "Clinical Decision Support"
}, {
  label: "Strategic Tech Advisory"
}, {
  label: "Infrastructure Audits"
}, {
  label: "Compliance & M&A Diligence"
}];
const serviceAreas = [{
  label: "Molecular Diagnostics"
}, {
  label: "Precision Genetics Lab"
}, {
  label: "Clinical Data Insights"
}, {
  label: "Health Informatics"
}, {
  label: "Secure Lab Operations"
}, {
  label: "Bio-Digital Innovation"
}, {
  label: "Global Tech Support"
}];
export default function Footer() {
  return <section data-section-id="231196" id="footer" style={{
    backgroundColor: "hsl(222, 47%, 4%)"
  }} className="w-full border-t border-white/10">
      {}
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">

          {}
          <div className="flex flex-col gap-5">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643670/img/ferguson_oneill_logo.png" alt="Eirion Technology - Integrated Clinical Innovation" className="h-7" />
            </Link>
            <p className="font-default text-sm leading-relaxed" style={{
            color: "hsl(210, 20%, 70%)"
          }}>
              Pioneering the intersection of clinical precision and technical excellence. Eirion delivers integrated solutions across fractional leadership, software platforms, and diagnostic services.
            </p>
            <div className="flex items-center gap-1 mt-1">
              <Leaf size={13} style={{
              color: "hsl(145, 80%, 50%)"
            }} />
              <span className="font-default text-xs uppercase tracking-widest" style={{
              color: "hsl(145, 80%, 50%)"
            }}>
                CLIA & CAP Certified Lab
              </span>
            </div>
            {}
            <div className="flex gap-4 mt-2">
              <Link to="#" className="transition-opacity opacity-60 hover:opacity-100 inline-block" style={{
              color: "hsl(210, 20%, 80%)"
            }} aria-label="Facebook">
                <Facebook size={18} />
              </Link>
              <Link to="#" className="transition-opacity opacity-60 hover:opacity-100 inline-block" style={{
              color: "hsl(210, 20%, 80%)"
            }} aria-label="Instagram">
                <Instagram size={18} />
              </Link>
              <Link to="#" className="transition-opacity opacity-60 hover:opacity-100 inline-block" style={{
              color: "hsl(210, 20%, 80%)"
            }} aria-label="Twitter">
                <Twitter size={18} />
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h4 className="font-default text-xs uppercase tracking-widest font-semibold mb-1" style={{
            color: "hsl(190, 90%, 50%)"
          }}>
              Integrated Pillars
            </h4>
            <ul className="flex flex-col gap-2">
              {services.map((service, i) => <li data-index={i} key={i}>
                  <Link to="#" className="font-default text-sm transition-opacity opacity-60 hover:opacity-100 inline-block" style={{
                color: "hsl(210, 20%, 85%)"
              }}>
                    {service.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h4 className="font-default text-xs uppercase tracking-widest font-semibold mb-1" style={{
            color: "hsl(270, 70%, 60%)"
          }}>
              Lab & Diagnostics
            </h4>
            <ul className="flex flex-col gap-2">
              {serviceAreas.map((area, i) => <li data-index={i} key={i}>
                  <span className="font-default text-sm opacity-60" style={{
                color: "hsl(210, 20%, 85%)"
              }}>
                    {area.label}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h4 className="font-default text-xs uppercase tracking-widest font-semibold mb-1" style={{
            color: "hsl(210, 20%, 80%)"
          }}>
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 opacity-60" style={{
                color: "hsl(210, 20%, 85%)"
              }} />
                <span className="font-default text-sm opacity-70 leading-relaxed" style={{
                color: "hsl(210, 20%, 85%)"
              }}>
                  Global Clinical Operations
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 shrink-0 opacity-60" style={{
                color: "hsl(210, 20%, 85%)"
              }} />
                <span className="font-default text-sm opacity-70" style={{
                color: "hsl(210, 20%, 85%)"
              }}>
                  Strategic Consultations
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 shrink-0 opacity-60" style={{
                color: "hsl(210, 20%, 85%)"
              }} />
                <span className="font-default text-sm opacity-70" style={{
                color: "hsl(210, 20%, 85%)"
              }}>
                  contact@eirion.tech
                </span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 mb-6">
          <Separator className="opacity-10" style={{
          backgroundColor: "hsl(210, 20%, 80%)"
        }} />
        </div>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-default text-xs opacity-40" style={{
          color: "hsl(210, 20%, 90%)"
        }}>
            &copy; {new Date().getFullYear()} Eirion Technology. All rights reserved.
          </p>
          <p className="font-default text-xs uppercase tracking-widest opacity-30" style={{
          color: "hsl(210, 20%, 90%)"
        }}>
            The Clinical Vanguard
          </p>
        </div>
      </div>
    </section>;
}